// extracted by mini-css-extract-plugin
export var container = "_ix-0";
export var content = "_ix-3";
export var customerTitle = "_ix-4";
export var empty = "_ix-5";
export var gray = "_ix-6";
export var header = "_ix-7";
export var info = "_ix-8";
export var loading = "_ix-2";
export var loadingCard = "_ix-9";
export var oneLine = "_ix-a";
export var personName = "_ix-e";
export var pillContainer = "_ix-b";
export var selected = "_ix-1";
export var text = "_ix-c";
export var twoLines = "_ix-d";
export var unread = "_ix-f";
export var unreadIndicator = "_ix-g";